import { useInfiniteQuery } from '@tanstack/react-query';

import { getNextPageParam } from '@pkg/hooks/deprecated';

import { callGetUserWishlists, WISHLISTS_DATA } from '@app/client/resources/wishlists';

export function useGetUserWishlists(userId: string) {
    const cache = [WISHLISTS_DATA, 'lists', userId];
    return useInfiniteQuery(
        cache,
        ({ pageParam = 0, signal }) =>
            callGetUserWishlists({
                userId,
                query: { page: pageParam || 0, limit: 10 },
                settings: { signal },
            }),
        {
            retry: false,
            getNextPageParam,
            enabled: !!userId?.length,
        },
    );
}
